import React, { memo } from 'react';
import moment from 'moment';
import { Grid, Theme } from '@material-ui/core';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';

import { FormattedMessage, useIntl } from 'react-intl';
import { ActionModal } from '../../../components/Modal';
import { Typography } from '../../../components/Typography';

const styles = (theme: Theme) => {
  return createStyles({
    userCard: {},
    right: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
    },
  });
};

export interface IMeetingInfoModalProps extends WithStyles<typeof styles> {
  open: boolean;
  meeting: any;
  handleClose: () => void;
}

const MeetingInfoModal = ({
  classes,
  open,
  meeting,
  handleClose,
}: IMeetingInfoModalProps) => {
  const intl = useIntl();
  return (
    <ActionModal
      modalTitle={meeting?.name}
      open={open}
      handleClose={handleClose}
      actinButtonLabel={intl.formatMessage({
        id: 'done',
      })}
      actinButtonOnClick={handleClose}
      isSingleButton
    >
      <Grid container className={classes.userCard}>
        <Grid item className={classes.right}>
          <Typography variant="body1" color="secondary">
            <FormattedMessage id="room" /> :&nbsp;{meeting?.location}
          </Typography>
          <Typography variant="body1" color="secondary">
            <FormattedMessage id="host" /> :&nbsp;{meeting?.host?.profile?.name}{' '}
            | &nbsp;
            {meeting?.host?.email}
          </Typography>
          <Typography variant="body1" color="secondary">
            <FormattedMessage id="time" /> :{' '}
            {moment(meeting?.beginTime).format('hh:mm A')}&nbsp;&nbsp;
            {meeting?.endTime && moment(meeting?.endTime).format('hh:mm A')}
          </Typography>
          <Typography variant="body1" color="secondary">
            <FormattedMessage id="group" /> :&nbsp;
            {meeting?.groupId?.name}
          </Typography>
          <Typography variant="body1" color="secondary">
            <FormattedMessage id="members" /> :&nbsp;
            {meeting?.members.map((member: any) => {
              return `${member?.userId?.profile?.name} | ${member?.userId?.email}, `;
            })}
          </Typography>
          {/* <Typography variant="body1" color="secondary">
            <FormattedMessage id="participants" /> : &nbsp;
            {meeting?.participantCount}
          </Typography> */}
        </Grid>
      </Grid>
    </ActionModal>
  );
};

export default memo(withStyles(styles)(MeetingInfoModal));
